import { ToastContainer, Zoom, type ToastContainerProps } from 'react-toastify'

import { CenteredToastStyle, DefaultToastStyle } from '@/shared/ui'

export const ACCOUNT_TOAST_CONTAINER_ID = 'ACCOUNT'

type Props = ToastContainerProps

export const AccountToastProvider = (props: Props) => {
  return (
    <ToastContainer
      autoClose={2000}
      transition={Zoom}
      toastClassName={[DefaultToastStyle, CenteredToastStyle].join(' ')}
      closeButton={false}
      hideProgressBar
      containerId={ACCOUNT_TOAST_CONTAINER_ID}
      {...props}
    />
  )
}
